import React from "react";
import { MdCall, MdLocationOn } from "react-icons/md";
import { BsFillEnvelopeFill } from "react-icons/bs";

function ContactSection2() {
  const phoneNumber = "+923014900495";
  const email = "atif@mbasolutions.com";
  const mapLink = "https://maps.app.goo.gl/QrpX2SFEX25deo8M7";
  const mapLink2 = "https://goo.gl/maps/7cvXBpX4e7CYaNxK9";
  const maplink3 = "https://maps.app.goo.gl/8ZHiNYBzCdKA7nLt5";

  const generateCallLink = () => {
    const url2 = `tel:${phoneNumber}`;
    return url2;
  };

  const contactCards = [
    {
      href: generateCallLink(),
      title: "Get In Touch",
      value: "+92 301 4900495",
      icon: <MdCall size={34} className="text-orange-500" />,
    },
    {
      href: `mailto:${email}`,
      title: "Drop Us A Line",
      value: email,
      icon: <BsFillEnvelopeFill size={30} className="text-orange-500" />,
    },
    {
      href: mapLink,
      title: "We Are Here",
      value: "525 Randall Ave Ste 100 Cheyenne, WY 82001",
      icon: <MdLocationOn size={34} className="text-orange-500" />,
    },
    {
      href: mapLink2,
      title: "We Are Here",
      value: "Office # 11-2 B2 Township, Lahore, Pakistan.",
      icon: <MdLocationOn size={34} className="text-orange-500" />,
    },
    {
      href: maplink3,
      title: "We Are Here",
      value:
        "Unit 11 Moses Gate Workshops, Gladys Street, Bolton, England, BL3 2QG",
      icon: <MdLocationOn size={34} className="text-orange-500" />,
    },
  ];

  return (
    <>
      <div className="mt-10 md:mt-14 mb-20 md:mb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 md:gap-6 items-stretch md:mx-10 cursor-pointer">
          {contactCards.map((card) => (
            <a
              key={`${card.title}-${card.value}`}
              href={card.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group"
            >
              <div className="relative text-center rounded-[22px] p-7 md:p-8 min-h-[220px] bg-white shadow-md border border-transparent hover:border-orange-200 hover:shadow-2xl transition-all duration-300 ease-out h-full">
                <div className="w-14 h-14 mx-auto rounded-full bg-orange-50 border border-orange-100 flex items-center justify-center group-hover:scale-105 transition-transform duration-300">
                  {card.icon}
                </div>
                <h5 className="font-semibold text-[22px] mt-7 mb-4 leading-[1.2] text-[#1B1C19]">
                  {card.title}
                </h5>
                <p className="font-light text-[15px] leading-6 text-[#3f4046] max-w-[280px] mx-auto">
                  {card.value}
                </p>
                <span className="absolute left-0 right-0 bottom-0 h-1 bg-orange-500 rounded-b-[22px] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-center" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </>
  );
}

export default ContactSection2;
